import { lazy } from 'react';
import { authRoles } from 'app/auth';

const ChatAIAppConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    auth: authRoles.user,
    routes: [
        {
            path: '/dalos-ai',
            component: lazy(() => import('./index.js'))
        }
    ]
};

export default ChatAIAppConfig;
